import React, { Component } from 'react';
import $ from 'jquery';
import {Link, browserHistory} from 'react-router';
import { Tabs, Tab , Modal,Panel,Breadcrumb } from 'react-bootstrap';
import { ShareButtons, generateShareIcon } from 'react-share';
import WebHeaderInner from './WebHeaderInner.js';
import WebFooter from './WebFooter.js';

const {FacebookShareButton,GooglePlusShareButton,TwitterShareButton} = ShareButtons;
const FacebookIcon = generateShareIcon('facebook');
const TwitterIcon = generateShareIcon('twitter');
const GooglePlusIcon = generateShareIcon('google');


export default class Web_PromoOffersZones extends Component{
	constructor(){
		super();
		this.state={
			key: 1,
			gen_offers: [],
			seed_offers: [],
			product_offers:[],
			gen_offers_status: true,
			seed_offers_status: true,
			product_offers_status: true,
			modal_gen: false,
			modal_seed: false,
			modal_feed: false,
		};
		this.handleSelect=this.handleSelect.bind(this);
	}
	componentDidMount(){
		localStorage.removeItem('w_r_s_dt');
	    localStorage.removeItem('w_r_e_coupon_dt');
	    localStorage.removeItem('w_r_e_s_dt');
	    localStorage.removeItem('web_mycart');
	    localStorage.removeItem('w_r_enq_seller_page');
	    localStorage.removeItem('w_r_p_dt');
	    localStorage.removeItem('w_r_e_p_dt');
	    
	    localStorage.removeItem('profile');
	    localStorage.removeItem('myaquacash');
	    localStorage.removeItem('web_share_earn');
	    localStorage.removeItem('checkout');
	    localStorage.removeItem('order_details');
	    localStorage.removeItem('myorders');
	    localStorage.removeItem('w_r_p_deals');
	    localStorage.removeItem('seed');
	    localStorage.removeItem('nauplii');
	    localStorage.removeItem('subdeals');
	    localStorage.removeItem('shipping');
	    localStorage.removeItem('notifications');
	    localStorage.removeItem('web_quickcart');
	    localStorage.removeItem('view_rating');
	    localStorage.removeItem('w_modal_seed');
	    localStorage.removeItem('w_r_seed_deals');
	    localStorage.removeItem('w_r_e_p_dt');
	    localStorage.removeItem('w_modal_details');
	    localStorage.removeItem('offers');
	    localStorage.removeItem('give_rating');
	    localStorage.removeItem('pprice');
	    localStorage.removeItem('sprice');
	    localStorage.removeItem('seed_id');
	    localStorage.removeItem('h_type');
	    localStorage.removeItem('web_pro_ofr_dtls');
	    localStorage.removeItem('web_wishlist');
	    localStorage.removeItem('web_brand_details');

	    localStorage.removeItem('m_r_s_dt');
	    localStorage.removeItem('m_r_e_coupon_dt');
	    localStorage.removeItem('m_r_e_s_dt');
	    localStorage.removeItem('mob_mycart');
	    localStorage.removeItem('m_r_enq_seller_page');
	    localStorage.removeItem('m_r_p_dt');
	    localStorage.removeItem('m_r_e_p_dt');
	    localStorage.removeItem('ofr_page');
	    localStorage.removeItem('pro_ofr_dtls');

	    localStorage.removeItem('share_earn');
	    localStorage.removeItem('my_orders');
	    localStorage.removeItem('m_r_p_deals');
	    localStorage.removeItem('mob_quickcart');
	    localStorage.removeItem('partner_deals');




		if(screen.width < 800){
   			 window.location.href="/offerszone";
  		}
		// if(!localStorage.token && !localStorage.user_id){
			localStorage.setItem('web_ofr_page','/web/offerszone');
		// 	browserHistory.push('/web/login');
		// }
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from:'desktop_web',uid:localStorage.getItem('user_id'),token:localStorage.getItem('token'),tab:'general'}
		var data2=JSON.stringify(data1);
		var data3={from:'desktop_web',uid:localStorage.getItem('user_id'),token:localStorage.getItem('token'),tab:'seed'};
		var data4=JSON.stringify(data3);
		var data5={from:'desktop_web',uid:localStorage.getItem('user_id'),token:localStorage.getItem('token'),tab:'product'};
		var data6=JSON.stringify(data5);
		$.ajax({
			method: 'POST',
			url:baseUrl+'getPromoOffers',
			dataType: 'json',
			data: {req:data2},
			success: function(data){
				console.log(data);
				if(data.status==='available'){
					this.setState({
						gen_offers: data.offers,
					});	
				}
				else{
					this.setState({
						gen_offers_status: false,
					});
				}
			}.bind(this),
			error: function(err){
				console.log(err);
			}
		});
		$.ajax({
			method: 'POST',
			url:baseUrl+'getPromoOffers',
			dataType: 'json',
			data: {req:data4},
			success: function(data){
				if(data.status==='available'){
					this.setState({
						seed_offers: data.offers,
					});	
				}
				else{
					this.setState({
						seed_offers_status: false,
					});
				}

			}.bind(this),
			error: function(err){
				console.log(err);
			}
		});
		$.ajax({
			method: 'POST',
			url:baseUrl+'getPromoOffers',
			dataType: 'json',
			data: {req:data6},
			success: function(data){
				if(data.status==='available'){
					this.setState({
						product_offers: data.offers,
					});
				}
				else{
					this.setState({
						product_offers_status: false,
					});
				}

			}.bind(this),
			error: function(err){
				console.log(err);
			}
		});
	}

	handleSelect(key){
		this.setState({
			key: key,
		});
	}
	
	render(){
		document.title="Offers Zone | AquaDeals";
		document.getElementsByTagName("META")[2].content="AquaDeals Offers Zone";
		var gen_offers = '';
		var seed_offers = '';
		var product_offers='';

		if(this.state.gen_offers_status)
		{
			gen_offers = this.state.gen_offers.map((offer,index) =>(<GenOffers key={offer.id} data={offer} />) );
		}
		else
		{
			gen_offers=<div className="web_no_offers"><Link to={"/web/customer_care"}><img src={'https://aquadeals.in/admin/assets/images/web_imgs/cc_orange_offers.png'} width="33px" alt=" " /><p className="web_ofr_care">Call customer care for best offers.</p></Link></div>
		}
		
		if(this.state.seed_offers_status)
		{
			seed_offers = this.state.seed_offers.map((offer,index) => (<SeedOffers key={offer.id} data={offer} /> ));	
		}
		else
		{
			seed_offers=<div className="web_no_offers"><Link to={"/web/customer_care"}><img src={'https://aquadeals.in/admin/assets/images/web_imgs/cc_orange_offers.png'} width="33px" alt=" " /><p className="web_ofr_care">Call customer care for best offers.</p></Link></div>
		}
		if(this.state.product_offers_status)
		{
			product_offers = this.state.product_offers.map((offer,index) => (<ProductOffers key={offer.id} data={offer} />));
		}
		else
		{
			product_offers =<div className="web_no_offers"><Link to={"/web/customer_care"}><img src={'https://aquadeals.in/admin/assets/images/web_imgs/cc_orange_offers.png'} width="33px" alt=" " /><p className="web_ofr_care">Call customer care for best offers.</p></Link></div>
		}
		return (
			<div className="Web_Deals web_Offer_page">
				<WebHeaderInner /> 
				<div className="clr">&nbsp;</div>
				<div className="clr">&nbsp;</div>
				<div className="clr">&nbsp;</div>
				<div className="clr">&nbsp;</div>
				<div className="clr">&nbsp;</div>
				<div className="clr">&nbsp;</div>
				<div className='container'>
				   <Breadcrumb className="ofrzone_breadcrmb">
			          <Breadcrumb.Item href="/web/home" >Home</Breadcrumb.Item>
			          <Breadcrumb.Item active>Offers Zone</Breadcrumb.Item>
		           </Breadcrumb>
				</div>
				<section className="container offer_content">
					<Tabs activeKey={this.state.key} onSelect={this.handleSelect} id="controlled-tab-example" className="justified offertab">
				        <Tab eventKey={1} title="AD OFFERS">{gen_offers}</Tab>
				        <Tab eventKey={2} title="SEED">{seed_offers}</Tab>
				        <Tab eventKey={3} title="PRODUCTS">{product_offers}</Tab>
				    </Tabs>
				</section>
				<div className="clr"></div>
				<WebFooter /> 
			</div>
		);
	}
}

	class GenOffers extends Component{
		constructor(props){
			super(props);
			this.state={
				modal_gen: false,
				offers: this.props.data,
				title: '',
				description: '',
				terms: '',
				discount_type: '',
				details: [],
				share_title: '',
				share_desc: '',
				share_panel_open: false,
			};
			this.close=this.close.bind(this);
			this.getPromoDetails=this.getPromoDetails.bind(this);
			this.getInvite=this.getInvite.bind(this);
		}

		getPromoDetails(offer_id){
			var baseUrl='https://aquadeals.in/admin/web3/user/';
			var data1={from:'desktop_web',id:localStorage.getItem('user_id'),token:localStorage.getItem('token'),ofr_id:offer_id}
			var data2=JSON.stringify(data1);
			$.ajax({
				method:'post',
				url: baseUrl+"get_promo_ofr",
				dataType: 'json',
				data: {req:data2},
				success: function(data){
					var details=$.makeArray(data.data);
					
					window.test=details;
					this.setState({
						details: details,
						title: details[0].title,
						description: details[0].description,
						terms: details[0].terms,
						discount_type: details[0].discount_type,
						share_panel_open: false,
					});
				}.bind(this),
				error:function(err){
					console.log(err);
				}
			});
		}
		close(){
			this.setState({modal_gen: false});
		}
		getInvite(){
			var baseUrl='https://aquadeals.in/admin/web3/user/';
			var data1={from:'desktop_web',id:localStorage.getItem('user_id'),token:localStorage.getItem('token')};
			var data2=JSON.stringify(data1);
			$.ajax({
				method:'post',
				url: baseUrl+'shareAppurl',
				dataType: 'json',
				data:{req:data2},
				success:function(data){
	
					this.setState({
						share_title: data.share_data,
						share_desc: data.share_data,
						share_panel_open: !this.state.share_panel_open,
					});
				}.bind(this),
				error:function(err){
					console.log(err);
				}
			});
		}

		render(){
			var offers=this.props.data;
			var shareUrl='http://tinyurl.com/aquadotdeals';

			return(
                 <div className="web_ofrs_blk col-md-6">
					<Link>
						<div className="web_offer_info" onClick={()=>{this.setState({modal_gen: true})}}><img src={'https://aquadeals.in/admin/assets/images/web_imgs/info.png'} width="20px" alt="" /></div>
						<div>
							<img onClick={()=>{this.setState({modal_gen: true})}} src={'https://aquadeals.in/admin/assets/images/promo_offers/'+offers.image} alt=" " />
						</div>
					</Link>
					<Modal onEntered={()=>{this.getPromoDetails(offers.id)}} className="" show={this.state.modal_gen} onHide={this.close} >
						<Modal.Header className="modal_offer_header" closeButton>
		            		<Modal.Title style={{fontSize: 18+'px',color:'#fff'}}>Offer Details</Modal.Title>
		          		</Modal.Header>
		          		<Modal.Body className="modal_details_block">
							<h4 className="modal_ofr_title">{this.state.title}</h4>
		          			<h6 className="modal_ofr_applicable">Applicable On: {this.state.discount_type}</h6>
		          			<p className="modal_ofr_period">Limited period offer</p>
		          			<h4 className="modal_ofr_desc_title">Description</h4>
		          			<p className="modal_ofr_desc">{this.state.description}</p>
		          			<h4 className="modal_ofr_terms_title">Terms and Conditions</h4>
		          			<div className="modal_ofr_terms" dangerouslySetInnerHTML={{__html: this.state.terms}}></div>
							{this.state.title === 'Refer & Earn' ? <div><div className="ofr_invite_btn"><a onClick={()=>{this.getInvite()}}>INVITE NOW</a></div> 
							<div className="ofr_share_panel">
								<Panel className="" style={{marginLeft:'30%'}} collapsible expanded={this.state.share_panel_open}>
                                  <FacebookShareButton url={shareUrl} title={this.state.share_title} className="test_share2">
                                    <FacebookIcon size={32} round />
                                  </FacebookShareButton>
                                  <TwitterShareButton url={shareUrl} title={this.state.share_title} description={shareUrl} className="test_share2">
                                    <TwitterIcon size={32} round />
                                  </TwitterShareButton>
								  <GooglePlusShareButton url={shareUrl} title={this.state.share_title} description={shareUrl} className="test_share2">
                                      <GooglePlusIcon size={32} round />
                                  </GooglePlusShareButton>
                              </Panel>
							</div></div> : ''}
		          		</Modal.Body>
		          	</Modal>	
				</div>
				
				
			);	
		}
	}

	class SeedOffers extends Component{
		constructor(props){
			super(props);
			this.state={
				modal_gen: false,
				offers: this.props.data,
				title: '',
				description: '',
				terms: '',
				discount_type: '',
				details: [],
				share_title: '',
				share_desc: '',
				share_panel_open: false,
			};
			this.close=this.close.bind(this);
			this.getPromoDetails=this.getPromoDetails.bind(this);
			this.getInvite=this.getInvite.bind(this);
		}
		getPromoDetails(offer_id){
			var baseUrl='https://aquadeals.in/admin/web3/user/';
			var data1={from:'desktop_web',id:localStorage.getItem('user_id'),token:localStorage.getItem('token'),ofr_id:offer_id}
			var data2=JSON.stringify(data1);
			$.ajax({
				method:'post',
				url: baseUrl+"get_promo_ofr",
				dataType: 'json',
				data: {req:data2},
				success: function(data){
					var details=$.makeArray(data.data);
					// console.log(data);
					console.log(details);
					window.test=details;
					this.setState({
						details: details,
						title: details[0].title,
						description: details[0].description,
						terms: details[0].terms,
						discount_type: details[0].discount_type,
						share_panel_open: false,
					});
				}.bind(this),
				error:function(err){
					console.log(err);
				}
			});
		}
		close(){
			this.setState({modal_gen: false});
		}
		getInvite(){
			var baseUrl='https://aquadeals.in/admin/web3/user/';
			var data1={from:'desktop_web',id:localStorage.getItem('user_id'),token:localStorage.getItem('token')};
			var data2=JSON.stringify(data1);
			$.ajax({
				method:'post',
				url: baseUrl+'shareAppurl',
				dataType: 'json',
				data:{req:data2},
				success:function(data){
					
					this.setState({
						share_title: data.share_data,
						share_desc: data.share_data,
						share_panel_open: !this.state.share_panel_open,
					});
				}.bind(this),
				error:function(err){
					console.log(err);
				}
			});
		}

		render(){
			var offers=this.props.data;
			var shareUrl='http://tinyurl.com/aquadotdeals';
			return(
				<div className="web_ofrs_blk col-md-6">
					<Link>
						<div className="web_offer_info" onClick={()=>{this.setState({modal_gen: true})}}><img src={'https://aquadeals.in/admin/assets/images/web_imgs/info.png'} width="20px" alt="" /></div>
						<div>
							<img onClick={()=>{this.setState({modal_gen: true})}} src={'https://aquadeals.in/admin/assets/images/promo_offers/'+offers.image} alt="" />
						</div>
						
					</Link>
					
					<Modal onEntered={()=>{this.getPromoDetails(offers.id)}} className="" show={this.state.modal_gen} onHide={this.close} >
						<Modal.Header className="modal_offer_header" closeButton>
		            		<Modal.Title style={{fontSize: 18+'px',color:'#fff'}}>Offer Details</Modal.Title>
		          		</Modal.Header>
		          		<Modal.Body className="modal_details_block">
							<h4 className="modal_ofr_title">{this.state.title}</h4>
		          			<h6 className="modal_ofr_applicable">Applicable On: {this.state.discount_type}</h6>
		          			<p className="modal_ofr_period">Limited period offer</p>
		          			<h4 className="modal_ofr_desc_title">Description</h4>
		          			<p className="modal_ofr_desc">{this.state.description}</p>
		          			<h4 className="modal_ofr_terms_title">Terms and Conditions</h4>
		          			<div className="modal_ofr_terms" dangerouslySetInnerHTML={{__html: this.state.terms}}></div>
							{this.state.title === 'Refer & Earn' ? <div><div className="ofr_invite_btn"><a onClick={()=>{this.getInvite()}}>INVITE NOW</a></div> 
							<div className="ofr_share_panel">
								<Panel className="" style={{marginLeft:'30%'}} collapsible expanded={this.state.share_panel_open}>
                                  <FacebookShareButton url={shareUrl} title={this.state.share_title} className="test_share2">
                                    <FacebookIcon size={32} round />
                                  </FacebookShareButton>
                                  <TwitterShareButton url={shareUrl} title={this.state.share_title} description={shareUrl} className="test_share2">
                                    <TwitterIcon size={32} round />
                                  </TwitterShareButton>
								  <GooglePlusShareButton url={shareUrl} title={this.state.share_title} description={shareUrl} className="test_share2">
                                      <GooglePlusIcon size={32} round />
                                  </GooglePlusShareButton>
                              </Panel>
							</div></div> : ''}
		          		</Modal.Body>
		          	</Modal>	
				</div>
			);
		}
	}

	class ProductOffers extends Component{
		constructor(props){
			super(props);
			this.state={
				modal_gen: false,
				offers: this.props.data,
				title: '',
				description: '',
				terms: '',
				discount_type: '',
				details: [],
				share_title: '',
				share_desc: '',
				share_panel_open: false,
			};
			this.close=this.close.bind(this);
			this.getPromoDetails=this.getPromoDetails.bind(this);
			this.getInvite=this.getInvite.bind(this);
		}

		getPromoDetails(offer_id){
			var baseUrl='https://aquadeals.in/admin/web3/user/';
			var data1={from:'desktop_web',id:localStorage.getItem('user_id'),token:localStorage.getItem('token'),ofr_id:offer_id}
			var data2=JSON.stringify(data1);
			$.ajax({
				method:'post',
				url: baseUrl+"get_promo_ofr",
				dataType: 'json',
				data: {req:data2},
				success: function(data){
					var details=$.makeArray(data.data);
					window.test=details;
					this.setState({
						details: details,
						title: details[0].title,
						description: details[0].description,
						terms: details[0].terms,
						discount_type: details[0].discount_type,
						share_panel_open: false,
					});
				}.bind(this),
				error:function(err){
					console.log(err);
				}
			});
		}
		close(){
			this.setState({modal_gen: false});
		}
		getInvite(){
			var baseUrl='https://aquadeals.in/admin/web3/user/';
			var data1={from:'desktop_web',id:localStorage.getItem('user_id'),token:localStorage.getItem('token')};
			var data2=JSON.stringify(data1);
			$.ajax({
				method:'post',
				url: baseUrl+'shareAppurl',
				dataType: 'json',
				data:{req:data2},
				success:function(data){
					this.setState({
						share_title: data.share_data,
						share_desc: data.share_data,
						share_panel_open: !this.state.share_panel_open,
					});
				}.bind(this),
				error:function(err){
					console.log(err);
				}
			});
		}


		render(){
			var offers=this.props.data;
			var shareUrl='http://tinyurl.com/aquadotdeals';
			return(
				<div className="web_ofrs_blk col-md-6">
					<Link>
						<div className="web_offer_info" onClick={()=>{this.setState({modal_gen: true})}}><img src={'https://aquadeals.in/admin/assets/images/web_imgs/info.png'} width="20px" alt="" /></div>
						<div>
							<img onClick={()=>{this.setState({modal_gen: true})}} src={'https://aquadeals.in/admin/assets/images/promo_offers/'+offers.image} alt="" />
						</div>
					</Link>
					
					<Modal onEntered={()=>{this.getPromoDetails(offers.id)}} className="" show={this.state.modal_gen} onHide={this.close} >
						<Modal.Header className="modal_offer_header" closeButton>
		            		<Modal.Title style={{fontSize: 18+'px',color:'#fff'}}>Offer Details</Modal.Title>
		          		</Modal.Header>
		          		<Modal.Body className="modal_details_block">
							<h4 className="modal_ofr_title">{this.state.title}</h4>
		          			<h6 className="modal_ofr_applicable">Applicable On: {this.state.discount_type}</h6>
		          			<p className="modal_ofr_period">Limited period offer</p>
		          			<h4 className="modal_ofr_desc_title">Description</h4>
		          			<p className="modal_ofr_desc">{this.state.description}</p>
		          			<h4 className="modal_ofr_terms_title">Terms and Conditions</h4>
		          			<div className="modal_ofr_terms" dangerouslySetInnerHTML={{__html: this.state.terms}}></div>
							{this.state.title === 'Refer & Earn' ? <div><div className="ofr_invite_btn"><a onClick={()=>{this.getInvite()}}>INVITE NOW</a></div> 
							<div className="ofr_share_panel">
								<Panel className="" style={{marginLeft:'30%'}} collapsible expanded={this.state.share_panel_open}>
                                  <FacebookShareButton url={shareUrl} title={this.state.share_title} className="test_share2">
                                    <FacebookIcon size={32} round />
                                  </FacebookShareButton>
                                  <TwitterShareButton url={shareUrl} title={this.state.share_title} description={shareUrl} className="test_share2">
                                    <TwitterIcon size={32} round />
                                  </TwitterShareButton>
								  <GooglePlusShareButton url={shareUrl} title={this.state.share_title} description={shareUrl} className="test_share2">
                                      <GooglePlusIcon size={32} round />
                                  </GooglePlusShareButton>
                              </Panel>
							</div></div> : ''}
		          		</Modal.Body>
		          	</Modal>	
				</div>
			);
		}
	}


/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Common/Web_promo_offerszone.js
 **/